/**
 * The portfolio on the page the user is looking at (the Asset Allocation page,
 * /assetAllocation/:portfolioId), or undefined when the route has none.
 *
 * Sent to the chat as its own field rather than as an entity type: the chat's
 * document and notes search switch on the entity type, and one they do not
 * recognise would widen their search instead of refusing it. See ChatContext.
 */
export const portfolioIdFromParams = (
  params?: { [key: string]: number | string | undefined }
): number | undefined => {
  const id = Number(params?.portfolioId);
  return Number.isInteger(id) && id > 0 ? id : undefined;
};
